import { render, staticRenderFns } from "./dataReportList.vue?vue&type=template&id=2349e7ba&scoped=true"
import script from "./dataReportList.vue?vue&type=script&lang=js"
export * from "./dataReportList.vue?vue&type=script&lang=js"
import style0 from "./dataReportList.vue?vue&type=style&index=0&id=2349e7ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2349e7ba",
  null
  
)

export default component.exports